import React, { useState } from "react";

export const useNodeRef = () => {
    const [nodeRef, setNodeRef] = useState(null);

    const handleNodeRef = node => {
        if (node instanceof Element) {
            setNodeRef(node);
        }
    }

    return { handleNodeRef, nodeRef };
}